module.exports = __webpack_public_path__ + "static/images/styles/images/reserves/inspiration.6b0f5bff.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/reserves/inspiration.png
// module id = 3724
// module chunks = 11